import styled from 'styled-components';

const FileButton = styled.label`
    display: block;
    border: 0.063rem solid ${props => props.isMultiple ? '#AAAAAA' : props.theme.color};
    color: ${props => props.isMultiple ? '#AAAAAA' : props.theme.color};
    font-size: 1rem;
    cursor: pointer;
    height: 3.125rem;
    line-height: 3.125rem;
    width: 100%;
    padding: 0 1.25rem;
    box-sizing: border-box;
`;

export default FileButton;